module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZThlYWVkIj48cGF0aCBkPSJNODAtMTYwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFpNODAtNDAwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFpNODAtNjQwdi0xNjBoMTYwdjE2MEg4MFptMjQwIDB2LTE2MGg1NjB2MTYwSDMyMFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/assets-24px.svg
// module id = TQK/
// module chunks = 1